import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import Avatar from '@mui/material/Avatar'
import Tooltip from '@mui/material/Tooltip'
import clsx from 'clsx'
import { downloadSecureDocument } from '../../../api/download'
import { displaySnackbar } from '../../../actions/main'
import styles from './styles/PatientHistoryDownloadDocumentStyles'
import DataTableActions from '../../Common/dataTableActions/DataTableActions'
import { useAppDispatch } from '../../../store'
import { PatientHistoryDownloadDocumentProps } from './_props'

const useStyles = makeStyles(styles)

const PatientHistoryDownloadDocument = ({ item, type, fileName }: PatientHistoryDownloadDocumentProps) => {
    const classes = useStyles()
    const dispatch = useAppDispatch()

    const download = async (uri: string) => {
        try {
            const data = await downloadSecureDocument(uri)
            const downloadLink = document.createElement('a')
            document.body.appendChild(downloadLink)
            downloadLink.href = URL.createObjectURL(data)
            downloadLink.download = `${fileName}.pdf`
            downloadLink.click()
        } catch (error) {
            dispatch(displaySnackbar('error', 'Impossible de récupérer le document'))
        }
    }

    const renderButton = () => (
        <DataTableActions
            actions={[
                {
                    onClick: () => {
                        // @ts-expect-error TS(2322) FIXME: Type '() => void' is not assignable to type 'never... Remove this comment to see the full error message
                        download(item.downloadUrl, type)
                    },
                    disabled: item.hasBeenRemoved,
                    icon: (
                        <Avatar
                            src={`/document-icons/${type}-trans.png`}
                            className={clsx(classes.small, classes.tintColorGray)}
                            variant="square"
                        />
                    ),
                },
            ]}
        />
    )

    return (
        <div>
            {item.hasBeenRemoved ? (
                <Tooltip placement="right" title="Document supprimé - Date de conservation dépassée">
                    <span>{renderButton()}</span>
                </Tooltip>
            ) : (
                renderButton()
            )}
        </div>
    )
}

export default PatientHistoryDownloadDocument
